<template>
  <section ref="itemsContainer" class="component-products-list">
    <ul class="d-flex flex-wrap flex-row p-0 mx-3 justify-content-center">
      <li v-for="(product, index) in products" :key="index" class="d-flex mx-1 my-2">
        <ProductCard :item="product" />
      </li>
    </ul>
  </section>
</template>

<script>
import ProductCard from '@/components/ProductCard.vue'

export default {
  name: 'ProductListWithoutCarousel',
  components: {
    ProductCard
  },
  props: {
    products: {
      type: Array,
      default: () => []
    }
  }
}
</script>
